<template>
  <HeraConfirm
    :text="
      this.$t(
        '_web_error-unable-to-copy-link',
        `Can't copy link to clipboard, try do it by yourself`
      )
    "
    :cancel-button-text="false"
    :confirm-button-text="confirmBtnLabel || $t('_web_leave-confirm-ok', 'OK')"
    @confirm="confirmLeave"
  >
    <p class="text-center mt-4">
      {{ link }}
    </p>
  </HeraConfirm>
</template>

<script>
import HeraConfirm from './HeraConfirm';
import { mapActions } from 'vuex';

export default {
  name: 'HeraConfirmLeave',
  components: { HeraConfirm },

  props: {
    link: {
      type: String,
      default: '',
    },
  },

  methods: {
    ...mapActions(['closeModal']),
    confirmLeave() {
      this.closeModal(false);
    },
  },
};
</script>
